import React from 'react';

class Comments extends React.Component {
    renderComment(photoId, comment, i) {
        return (
            <div key={i}>
                <h3>{comment.user}</h3>
                <p>{comment.text}</p>
                <button onClick={this.props.removeComment.bind(null, photoId, i)}>&times;</button>
            </div>
        )
    }

    handleSubmit = (e) => {
      e.preventDefault();
      console.log(this.refs)
      const { photoId } = this.props;
      const author = this.refs.author.value;
      const text = this.refs.comment.value
      console.log('stuff', photoId, author, text)
      this.props.addComment(photoId, author, text);
      this.refs.commentForm.reset();
    }

    render() {
        const { comments, photoId } = this.props;
        console.log('comments', comments)
        return (
            <div>
                {comments.map(this.renderComment.bind(this, photoId))}
                <form ref="commentForm" onSubmit={this.handleSubmit}>
                    <input type="text" ref="author" placeholder="user" />
                    <input type="text" ref="comment" placeholder="comment" />
                    <input type="submit" hidden />
                </form>
            </div>
        )
    }
}

export default Comments;


// WEBPACK FOOTER //
// ./src/components/photogram/comments.js